import { create } from "zustand";
import { SellarCreditStatementSortType } from "./SellarCreditStatementTypes";
import dayjs from "dayjs";
import { InvoiceStatusEnumType } from "@sellar-io/api-v2/types";
import { EntityType } from "./SellarCreditOrderStore";

type SellarCreditStatementState = {
  business: EntityType | null;
  columnSort: SellarCreditStatementSortType;
  documentMonth: string;
  documentTotalMin: string;
  documentTotalMax: string;
  excludeCreditNotes: boolean;
  paymentStatuses: InvoiceStatusEnumType[];
  scrollOffset: number;
  search: string;
  user: EntityType | null;
};

type SellarCreditStatementActions = {
  setBusiness: (business: EntityType | null) => void;
  setColumnSort: (columnSort: SellarCreditStatementSortType) => void;
  setDocumentMonth: (documentMonth: string) => void;
  setDocumentTotalMin: (documentTotalMin: string) => void;
  setDocumentTotalMax: (documentTotalMax: string) => void;
  setExcludeCreditNotes: (excludeCreditNotes: boolean) => void;
  setPaymentStatuses: (paymentStatuses: InvoiceStatusEnumType[]) => void;
  setScrollOffset: (scrollOffset: number) => void;
  setSearch: (search: string) => void;
  setUser: (user: EntityType | null) => void;
  reset: () => void;
  setState: (state: SellarCreditStatementState) => void;
};

const initialState: SellarCreditStatementState = {
  business: null,
  columnSort: "createdAt_desc",
  documentMonth: dayjs().subtract(1, "month").format("YYYY-MM"),
  documentTotalMin: "",
  documentTotalMax: "",
  excludeCreditNotes: false,
  paymentStatuses: [],
  scrollOffset: 0,
  search: "",
  user: null,
};

export const useSellarCreditStatementStore = create<
  SellarCreditStatementState & SellarCreditStatementActions
>((set) => ({
  ...initialState,
  setBusiness: (business: EntityType | null) => set({ business }),
  setColumnSort: (columnSort: SellarCreditStatementSortType) =>
    set({ columnSort }),
  setDocumentMonth: (documentMonth: string) => set({ documentMonth }),
  setDocumentTotalMin: (documentTotalMin: string) => set({ documentTotalMin }),
  setDocumentTotalMax: (documentTotalMax: string) => set({ documentTotalMax }),
  setExcludeCreditNotes: (excludeCreditNotes: boolean) =>
    set({ excludeCreditNotes }),
  setPaymentStatuses: (paymentStatuses: InvoiceStatusEnumType[]) =>
    set({ paymentStatuses }),
  setScrollOffset: (scrollOffset: number) => set({ scrollOffset }),
  setSearch: (search: string) => set({ search }),
  setUser: (user: EntityType | null) => set({ user }),
  reset: () =>
    set((state) => ({ ...initialState, documentMonth: state.documentMonth })),
  setState: (state) => set(state),
}));
